import styled from 'styled-components';
import { media, unless } from 'utils';

export const Wrapper = styled.div`
  margin: 5rem;

  @media (max-width: 768px) {
    margin: 5rem 2rem;
  }
`;

export const CurrentModuleTitle = styled.div`
  margin-top: 2.7rem;
  margin-bottom: 2.4rem;

  ${media.mobile`
    display: none;
  `}
`;

export const TitleTopRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ModuleIndex = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.standard.text.primary};
  letter-spacing: 0.1em;
`;

export const ViewAllModules = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
  font-size: 1.4rem;
  letter-spacing: 0.006em;
  color: ${({ theme }) => theme.colors.standard.text.primary};
`;

export const ModuleTitle = styled.div`
  font-weight: 600;
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.colors.standard.text.primary};
`;

export const SessionCount = styled.div`
  letter-spacing: 0.006em;
  line-height: 3rem;
  color: ${({ theme }) => theme.colors.standard.text.primary};
`;

export const LessonList = styled.div<{ active?: boolean }>`
  > a > div {
    margin: 0.9rem 0;
  }

  ${media.mobile`
    ${unless('active')`
      display: none;
    `}
  `}
`;

export const AllModulesTitle = styled.div`
  margin-top: 6.5rem;
  margin-bottom: 2.2rem;
  font-size: 2rem;
  letter-spacing: 0.006em;
  color: ${({ theme }) => theme.colors.standard.text.primary};

  ${media.mobile`
    display: none;
  `}
`;

export const ModuleList = styled.div`
  > * {
    margin: 0.6rem 0;
  }

  ${media.mobile`
    ${unless('active')`
      display: none;
    `}
  `}
`;

export const MobileTabs = styled.div`
  width: 100%;
  justify-content: center;
  margin-top: 1.8rem;
  margin-bottom: 2.6rem;
  display: none;

  ${media.mobile`
    display: flex;
  `}
`;

export const MobileTitle = styled.div<{ active?: boolean }>`
  width: 100%;
  text-align: center;
  font-size: 1.6rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.standard.text.primary};
  margin-bottom: 1rem;

  display: none;
  ${media.mobile`
    display: block;

    ${unless('active')`
      display: none;
    `}
  `}
`;

export const MobileSubtitle = styled(MobileTitle)`
  font-size: 1.4rem;
  margin-bottom: 2.7rem;
`;
export const LoadWrapper = styled.div`
  min-height: 102px;
  width: 100%;
  background-color: #fff;
  padding: 2rem 4rem;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const LoadErrorWrapper = styled(LoadWrapper)`
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  text-align: center;
`;

export const Banner = styled.div`
  width: 100%;
  background-color: #fef3cd;
  border: 0.1rem solid #fecf47;
  border-radius: 0.4rem;
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
    padding: 1.2rem 1.5rem;
  }
`;

export const BannerContent = styled.div`
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.006em;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 1.3rem;
    line-height: 1.8rem;
  }
`;

export const BannerCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  font-weight: bold;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.2rem;
  flex-shrink: 0;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  &:focus {
    outline: 0.2rem solid rgba(0, 0, 0, 0.2);
    outline-offset: 0.1rem;
  }
`;
